const $ = require('jquery');

/**
 * Enum for event actions.
 *
 * @readonly
 * @enum {string}
 */
const EVENT_ACTION = {
    PDP: 'PDP',
    FLY_OUT: 'FlyOut',
    CART: 'Cart',
    SHIPPING: 'Shipping'
};

/**
 * Enum for event labels.
 *
 * @readonly
 * @enum {string}
 */
const EVENT_LABEL = {
    PICK_UP: 'Pick up at store',
    SHIP_TO_ME: 'Ship to me',
    FIND_STORES: 'Find stores',
    CONFIRM_STORE: 'Confirm your Store',
    SWITCH_LOCATION: 'Switch pickup location',
    SWITCH_TO_SHIPPING: 'Switch to shipping',
    DIFFERENT_CONTACT: 'Pickup contact is different than shipping contact'
};

/**
 * Pushes an BOPIS (Buy Online, Pick Up in Store) event to the dataLayer.
 *
 * @param {Object} eventData - The event data to be pushed to dataLayer.
 * @returns {void}
 */
function pushBopisEventToDataLayer(eventData) {
    if (!window.dataLayer) {
        return;
    }

    const event = {
        event: 'BOPIS',
        ...eventData
    };

    window.dataLayer.push(event);
}

module.exports = {
    /**
     * Records "Pick up at store" and "Ship to me" click events on the Product Detail Page (PDP).
     *
     * @param {boolean} isPickUp - Indicates the button type.
     */
    recordPDPClick(isPickUp) {
        pushBopisEventToDataLayer({
            event_action: EVENT_ACTION.PDP,
            event_label: isPickUp ? EVENT_LABEL.PICK_UP : EVENT_LABEL.SHIP_TO_ME
        });
    },

    /**
     * Records a click event for "Find stores" flyout button.
     */
    recordFindStoreClick() {
        pushBopisEventToDataLayer({
            event_action: EVENT_ACTION.FLY_OUT,
            event_label: EVENT_LABEL.FIND_STORES
        });
    },

    /**
     * Records a click event to confirm store selection inside flyout.
     */
    recordConfirmStoreClick() {
        pushBopisEventToDataLayer({
            event_action: EVENT_ACTION.FLY_OUT,
            event_label: EVENT_LABEL.CONFIRM_STORE
        });
    },

    /**
     * Records a tick event for "different than shipping contact" checkbox on shipping page.
     *
     * @param {boolean} checked - Indicates if the checkbox is checked or not.
     */
    recordDifferentContactTick(checked) {
        pushBopisEventToDataLayer({
            event_action: EVENT_ACTION.SHIPPING,
            event_label: EVENT_LABEL.DIFFERENT_CONTACT,
            event_category: checked ? 'checked' : 'unchecked'
        });
    },

    /**
     * Initializes cart-related events.
     */
    initCartEvents() {
        // Listen to "Switch pickup location" and "Switch to shipping" clicks
        $('body').on('click', '.flyin-store-finder, .item-switch-shipping', function () {
            pushBopisEventToDataLayer({
                event_action: EVENT_ACTION.CART,
                event_label: $(this).hasClass('flyin-store-finder')
                    ? EVENT_LABEL.SWITCH_LOCATION
                    : EVENT_LABEL.SWITCH_TO_SHIPPING
            });
        });
    }
};
